<template>
  <div class="view-tasklists account-lookup-view-list">
    <user-menu />
    <div class="wrapper">
      <masteradmin-sidebar-menu v-if="masterAdmin == true" />
      <CSRSidebarMenu v-if="csr == true" />
      <div class="content-wrapper">
        <div class="container-wrapper center">
          <div>
            <h3 class="d-inline heading">Enterprise Lookup</h3>
            <button
                v-on:click="clearSearch()"
                class="btn btn-red btn-md input-height-15 float-right text-align-right"
                >Search Again</button>
          </div>

          <div class="heading-seperator"></div>
          <div class="margin-bottom-10"></div>
          <div>
             <b-card no-body>
                <div class="row account_view_list_heading_row col-12">
                   <div
                    class="bold sno_field "
                    >
                    SI.No
                   </div>
                   <div
                     class="bold cursor-pointer account_name_field "
                     v-on:click="sortMethod('companyName')"
                     >
                     Enterprise Name
                     <span class="float-right padding-right-5 color-000">
                       <i v-if="sortField == 'companyName' && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                       <i v-if="sortField == 'companyName' && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                       <i v-if="sortField != 'companyName'" class="fa fa-sort" aria-hidden="true"></i>
                     </span>
                   </div>
                   <div
                     class="bold cursor-pointer first_name_field override-padding"
                     v-on:click="sortMethod('first_name')"
                     >
                     First Name
                     <span class="float-right padding-right-5 color-000">
                       <i v-if="sortField == 'first_name' && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                       <i v-if="sortField == 'first_name' && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                       <i v-if="sortField != 'first_name'" class="fa fa-sort" aria-hidden="true"></i>
                     </span>
                   </div>
                   <div
                     class="bold cursor-pointer last_name_field override-padding"
                     v-on:click="sortMethod('last_name')"
                     >
                     Last Name
                     <span class="float-right padding-right-5 color-000">
                       <i v-if="sortField == 'last_name' && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                       <i v-if="sortField == 'last_name' && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                       <i v-if="sortField != 'last_name'" class="fa fa-sort" aria-hidden="true"></i>
                     </span>
                   </div>
                   <div
                     class="bold cursor-pointer username_field override-padding"
                     v-on:click="sortMethod('username')"
                     >
                     Username
                     <span class="float-right padding-right-5 color-000">
                       <i v-if="sortField == 'username' && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                       <i v-if="sortField == 'username' && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                       <i v-if="sortField != 'username'" class="fa fa-sort" aria-hidden="true"></i>
                     </span>
                   </div>
                   <div
                     class="bold cursor-pointer address_field override-padding"
                     v-on:click="sortMethod('address')"
                     >
                     Address
                     <span class="float-right padding-right-5 color-000">
                       <i v-if="sortField == 'address' && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                       <i v-if="sortField == 'address' && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                       <i v-if="sortField != 'address'" class="fa fa-sort" aria-hidden="true"></i>
                     </span>
                   </div>
                   <div
                     class="bold cursor-pointer city_field  override-padding"
                     v-on:click="sortMethod('city')"
                     >
                     City
                     <span class="float-right padding-right-5 color-000">
                       <i v-if="sortField == 'city' && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                       <i v-if="sortField == 'city' && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                       <i v-if="sortField != 'city'" class="fa fa-sort" aria-hidden="true"></i>
                     </span>
                   </div>
                   <div
                     class="bold cursor-pointer state_field override-padding"
                     v-on:click="sortMethod('stateCode')"
                     >
                     State
                     <span class="float-right padding-right-5 color-000">
                       <i v-if="sortField == 'stateCode' && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                       <i v-if="sortField == 'stateCode' && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                       <i v-if="sortField != 'stateCode'" class="fa fa-sort" aria-hidden="true"></i>
                     </span>
                   </div>
                   <div
                     class="bold cursor-pointer zip_field override-padding"
                     v-on:click="sortMethod('zipCode')"
                     >
                     Zip
                     <span class="float-right padding-right-5 color-000">
                       <i v-if="sortField == 'zipCode' && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                       <i v-if="sortField == 'zipCode' && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                       <i v-if="sortField != 'zipCode'" class="fa fa-sort" aria-hidden="true"></i>
                     </span>
                   </div>
                   <div
                     class="bold cursor-pointer phone_field override-padding"
                     v-on:click="sortMethod('phoneNumber')"
                     >
                     Phone
                     <span class="float-right padding-right-5 color-000">
                       <i v-if="sortField == 'phoneNumber' && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                       <i v-if="sortField == 'phoneNumber' && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                       <i v-if="sortField != 'phoneNumber'" class="fa fa-sort" aria-hidden="true"></i>
                     </span>
                   </div>
                 </div>

                 <div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>

                 <b-card-text v-if="account_lists.length > 0">
                    <div class="view-accountlist">
                      <div v-for="(account_list, index) in account_lists" class="tasklist-row">
                        <div class="row tasklist-item col-12">
                          <div class="sno_field row_field">{{ sno + index + 1 }}</div>
                          <div class="account_name_field row_field cursor-pointer"
                            v-on:click="router_redirect(sno + index)"
                            >
                            {{ account_list.accountName }}
                          </div>
                          <div class="first_name_field row_field">{{ account_list.firstName }}</div>
                          <div class="last_name_field row_field">{{ account_list.lastName }}</div>
                          <div class="username_field row_field">{{ account_list.Username }}</div>
                          <div class="address_field row_field">{{ account_list.address }}</div>
                          <div class="city_field row_field">{{ account_list.city }}</div>
                          <div class="state_field row_field">{{ account_list.state }}</div>
                          <div class="zip_field row_field">{{ account_list.zip }}</div>
                          <div class="phone_field row_field">{{ account_list.phone }}</div>
                        </div>
                        <div><hr></div>
                      </div>
                    </div>
                    <div class="col-12 float-left override-padding pagination-wrapper">
                     <Pagination
                     ref="Pagination"
                     :currentPage="currentPage"
                     :totalRows="rows"
                     :perPage="perPage"
                     :showPaginatedFunction="showNaicsofPaginated"
                     :showPerPageFunction="perPagePaginated"
                     :totalPages="totalPages"
                     :sNo="sno"
                     >
                     </Pagination>
                    </div>
                 </b-card-text>
                 <b-card-text v-else-if="loading == false">
                      No enterprise found.
                 </b-card-text>
             </b-card>
           </div>
         </div>
       </div>
     </div>
  </div>
</template>

<script>

import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import GoBack from '../shared/goback.vue';
import axios from 'axios';
import { store } from '../../store/store';
import router from '../../router/index.js';
import Pagination from '../pagination.vue';
import MasteradminSidebarMenu from '../shared/masteradmin_sidebar_menu.vue';
import CSRSidebarMenu from '../shared/csr_sidebar_menu.vue';

export default {
        data() {
          return {
            rows: 0,
            perPage: 50,
            currentPage: 1,
            account_lists: [],
            loading: false,
            sortField: '',
            sortBy: '',
            searchParameters: {

            },
            sno: 0,
            pageOptions: [],
            totalPages: 0,
            researcher: false,
            masterAdmin: false,
            csr: false,
          }
        },

        components: {
          UserMenu,
          GoBack,
          Pagination,
          MasteradminSidebarMenu,
          CSRSidebarMenu,
        },
        methods: {
            router_redirect: function(page) {
              let routeData = this.$router.resolve({name: 'enterpriselookup', query: {count: page}});
              window.open(routeData.href, '_blank');
            },
            sortMethod: function(field) {
              this.sortField = field;
              if(this.sortBy == 'ASC') {
                this.sortBy = 'DESC';
              }
              else {
                this.sortBy = 'ASC';
              }
              this.searchParameters.sort.sortField = this.sortField;
              this.searchParameters.sort.sortBy = this.sortBy;
              store.dispatch('search_enterprise_parameters', this.searchParameters);
              this.fetchAccountList();
            },
            showNaicsofPaginated() {
              this.currentPage = this.$refs.Pagination.currentPageValue;
              this.fetchAccountList();
            },
            perPagePaginated() {
              this.currentPage = 1;
              this.$refs.Pagination.currentPageValue = 1;
              this.perPage = this.$refs.Pagination.perPageValue;
              this.fetchAccountList();
            },
            fetchAccountList: function() {
              this.loading = true;
              var searchParam = store.state.search_enterprise_parameters;
              searchParam.page = this.currentPage;
              searchParam.perPage = this.perPage;

              axios("/enterprise_lookup_search/view_list", {
                method: 'POST',
                data: {
                  search_enterprise_parameters: searchParam,
                }
              })
              .then(response => {
                this.loading = false;
                this.account_lists = response.data.data;
                this.currentPage = response.data.page;
                if(this.currentPage > 1) {
                  this.sno = this.perPage * (this.currentPage - 1);
                }
                else {
                  this.sno = 0;
                }
                this.rows = response.data.total_rows;
                this.totalPages = response.data.total_pages;
                if(this.account_lists.length == 0) {
                  this.flash({ message: "No enterprise found.", variant: 'danger' });
                  store.dispatch('search_enterprise_parameters', '');
                  router.push("/enterprise-lookup");
                }
              })
              .catch(error => {

              });
            },
            clearSearch: function() {
              store.dispatch('search_enterprise_parameters', '');
              this.flash({ message: "Search cleared.", variant: 'success' });
              router.push("/enterprise-lookup");
            }
        },
        mounted() {

        },
        created() {
          var roles = this.$store.state.roles;
          if(roles.indexOf('ROLE_MASTER_ADMIN') > -1) {
            this.masterAdmin = true;
          }
          if(roles.indexOf('ROLE_CSR') > -1) {
            this.csr = true;
          }
           document.body.className = 'naicslist-page';
           if(!store.state.search_enterprise_parameters) {
              router.push("/enterprise-lookup");
           }
           this.searchParameters = store.state.search_enterprise_parameters;
           this.fetchAccountList();
           this.sortField = store.state.search_enterprise_parameters.sort.sortField;
           this.sortBy = store.state.search_enterprise_parameters.sort.sortBy;
        },
    }
</script>

<style scoped>
@import '../../assets/styles/account_lookup.css';

.view-accountlist {
  min-height: 70vh;
}
.view-accountlist .tasklist-row:last-child{
  border-bottom: 1px solid #E5E5E5;
}

.account_view_list_heading_row {
    /* background-color: #dc2227; */
    background-color: #00ACEE;
    line-height: 25px;
    color: #FFF;
    padding: 3px 0px;
    margin-right: 0px !important;
    margin-left: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/enterprise_lookup_view_list.vue